import { IValidator, IForgotPassword, IValidations } from '@/interfaces';
import { isEmail } from '@/utils';

export class ForgotPasswordValidator implements IValidator<IForgotPassword> {
  public isValid(item: IForgotPassword) {
    const errors: IValidations<IForgotPassword> = {};
    // Validate email
    if (!isEmail(item.email)) errors.email = ['Email must be a valid email address'];
    return Object.keys(errors).length > 0 ? errors : true;
  }
}